let tilesetLayer;
export default {
  props: ["xAngle", "yAngle", "zAngle", "scalingRatio"],
  data() {
    return {
      modelRotation_show: true,
      xAngleNumber: 0,
      yAngleNumber: 0,
      zAngleNumber: 0,
      scalingRatioNumber: 1,
      currentTilesetLayerId: "",
      isFold: false,
    };
  },
  methods: {
    adjustXAngle(currentValue, oldValue) {
      let that = this;
      let cRes = this.showModel();
      if (!cRes) {
        setTimeout(function() {
          that.xAngleNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.xAngleNumber);
    },
    adjustYAngle(currentValue, oldValue) {
      let that = this;
      let cRes = this.showModel();
      if (!cRes) {
        setTimeout(function() {
          that.yAngleNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.yAngleNumber);
    },
    adjustZAngle(currentValue, oldValue) {
      let that = this;
      let cRes = this.showModel();
      if (!cRes) {
        setTimeout(function() {
          that.zAngleNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.zAngleNumber);
    },
    adjustScalingRatio(currentValue, oldValue) {
      let that = this;
      let cRes = this.showModel();
      if (!cRes) {
        setTimeout(function() {
          that.scalingRatioNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.scalingRatioNumber);
    },
    modelRotationBox_close() {
      //关闭弹窗则重置模型角度
      this.xAngleNumber = 0;
      this.yAngleNumber = 0;
      this.zAngleNumber = 0;
      this.scalingRatioNumber = 1;
      this.updateModel();
      this.$emit("modelRotationBox_close");
    },
    showModel() {
      //获取参数
      var params = this.getConfig();
      delete params.center;

      let that = this;
      // let currentLayerId = window.sessionStorage.getItem('currentLayerId');
      // tilesetLayer = this.$GLOBAL.map.getLayerById(currentLayerId);
      // console.log(tilesetLayer);
      // console.log(777777777777);
      if (!tilesetLayer) {
        params.url = "//data.mars3d.cn/3dtiles/max-fsdzm/tileset.json";
        tilesetLayer = new mars3d.layer.TilesetLayer({
          popup: "all",
          flyTo: true,
          ...params,
        });
        this.$GLOBAL.map.addLayer(tilesetLayer);
        // this.$alert('请先在页面左侧模型目录树里勾选并点击您要旋转的模型。', '友情提示', {
        // 	confirmButtonText: '确定',
        // 	type: "warning",
        // 	callback: action => {}
        // });
        // return false;
      } else {
        // if (currentLayerId !== this.currentTilesetLayerId) {
        // 	this.currentTilesetLayerId = currentLayerId;
        // }
        params.url = tilesetLayer.options.url;
        (params.popup = "all"),
          (params.flyTo = true),
          console.log(tilesetLayer.url);
        //alert(tilesetLayer.url)
        tilesetLayer.setOptions(params);
      }
      return true;
    },
    updateModel() {
      if (tilesetLayer) {
        //加个判断是为了能正常关闭弹窗。
        //获取参数
        var params = this.getConfig();
        params.rotation = params.rotation || {};
        params.rotation.x = params.rotation.x || 0;
        params.rotation.y = params.rotation.y || 0;
        params.rotation.z = params.rotation.z || 0;
        tilesetLayer.setOptions(params);
      }
    },
    getConfig() {
      var params = {
        name: "模型名称",
        type: "3dtiles",
        maximumMemoryUsage: 1024, // 【重要】内存分配变小有利于倾斜摄影数据回收，提升性能体验
        center: this.$GLOBAL.map.getCameraView(),
        show: true,
      };

      // var rotation_x = mars3d.Util.formatNum($("#txt_rotation_x").val(), 1);
      var rotation_x = mars3d.Util.formatNum(this.xAngleNumber, 1);
      if (rotation_x) {
        params.rotation = params.rotation || {};
        params.rotation.x = rotation_x;
      }

      // var rotation_y = mars3d.Util.formatNum($("#txt_rotation_y").val(), 1);
      var rotation_y = mars3d.Util.formatNum(this.yAngleNumber, 1);
      if (rotation_y) {
        params.rotation = params.rotation || {};
        params.rotation.y = rotation_y;
      }

      // var rotation_z = mars3d.Util.formatNum($("#txt_rotation_z").val(), 1);
      var rotation_z = mars3d.Util.formatNum(this.zAngleNumber, 1);
      if (rotation_z) {
        params.rotation = params.rotation || {};
        params.rotation.z = rotation_z;
      }

      // var scale = mars3d.Util.formatNum(Number($("#txt_scale").val()) || 1, 1);
      var scale = mars3d.Util.formatNum(
        Number(this.scalingRatioNumber) || 1,
        1
      );
      if (scale > 0) {
        params.scale = scale;
      }

      return params;
    },
  },
  mounted() {
    if (this.xAngle || this.xAngle === 0) {
      this.xAngleNumber = this.xAngle;
    }
    if (this.yAngle || this.yAngle === 0) {
      this.yAngleNumber = this.yAngle;
    }
    if (this.zAngle || this.zAngle === 0) {
      this.zAngleNumber = this.zAngle;
    }
    if (this.scalingRatio) {
      this.scalingRatioNumber = this.scalingRatio;
    }
    // let cRes = this.showModel();
    // if (!cRes) {
    // 	return false;
    // }
    this.showModel();
  },
  destroyed() {
    this.$GLOBAL.map.removeLayer(tilesetLayer, true); //测试模型时用
    tilesetLayer = null; //测试模型时用
    this.$message({
      message: "已清理展示旋转功能的示例模型。",
      offset: 100,
      showClose: true,
      duration: 2300,
    });
  },
  watch: {},
};
